import React from 'react'
import Typography from '@material-ui/core/Typography'
import FilterBar from 'components/DigitalLog/FilterBar'
import MyLogTable from 'components/DigitalLog/MyLogTable'

function MyLog(props) {
  return (
    <div className="module myLog-module">
      <div className="module-head">
        <Typography className="module-title" variant="h5">
          {props.currentApp.name}
        </Typography>
        <div className="module-filter">
          <FilterBar {...props} />
        </div>
      </div>
      <div className="module-content">
        <MyLogTable {...props} />
      </div>
    </div>
  )
}

export default MyLog
